/**
 * @fileoverview CMS’te tanımlı aktif diller (persist edilmez; her oturumda API’den yenilenir).
 */

import { createSlice } from '@reduxjs/toolkit'

/** API yok / hata durumunda dil menüsü için güvenli varsayılan */
export const DEFAULT_SITE_LANGUAGES = [
  { code: 'tr', name: 'Türkçe' },
  { code: 'en', name: 'English' },
  { code: 'ru', name: 'Русский' },
]

/** @type {{ languages: { code: string, name: string }[], loadStatus: 'idle' | 'loading' | 'ok' }} */
const initialState = {
  languages: DEFAULT_SITE_LANGUAGES,
  loadStatus: 'idle',
}

const siteLocaleSlice = createSlice({
  name: 'siteLocale',
  initialState,
  reducers: {
    setSiteLanguagesLoading: (state) => {
      state.loadStatus = 'loading'
    },
    setSiteLanguages: (state, action) => {
      state.languages = Array.isArray(action.payload) ? action.payload : []
      state.loadStatus = 'ok'
    },
  },
})

export const { setSiteLanguagesLoading, setSiteLanguages } = siteLocaleSlice.actions

/** @param {{ siteLocale: typeof initialState }} state */
export const selectSiteLanguages = (state) => state.siteLocale.languages
/** @param {{ siteLocale: typeof initialState }} state */
export const selectSiteLanguagesLoadStatus = (state) => state.siteLocale.loadStatus

export default siteLocaleSlice.reducer
